export function dateIsoToDate(dateIso: Date) {
  const date = new Date(dateIso);
  const newDate = new Date(date.toISOString().replace('Z', ''));
  return newDate;
}
